import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';
import { SlackUser } from '../entity';
import { SlackUserId } from '../value';

export abstract class ISlackUserRepository extends IRepository<SlackUserId, SlackUser> {
  abstract selectAll(builder: FirestoreQueryBuilder<SlackUser>): Observable<SlackUser>;
  abstract selectIfExists(id: SlackUserId): Observable<SlackUser> | null;
}
